<template>
  <pro-layout
    :menus="sideMenus"
    :collapsed="collapsed"
    :media-query="query"
    :is-mobile="isMobile"
    :handle-media-query="handleMediaQuery"
    :handle-collapse="handleCollapse"
    :i18n-render="i18nRender"
    v-bind="settings"
  >

    <!-- 1.0.0+ 版本 pro-layout 提供 API，
          我们推荐使用这种方式进行 LOGO 和 title 自定义
    -->
    <template v-slot:menuHeaderRender>
      <div>
        <img src="@/assets/logo.png" alt="logo">
        <h1>{{ title }}</h1>
      </div>
    </template>

    <setting-drawer v-if="isDev" :settings="settings" @change="handleSettingChange">
      <div style="margin: 12px 0;">
        This is SettingDrawer custom footer content.
      </div>
    </setting-drawer>
    <MultiTab v-if="multiTab" ref="multiTab" />
    <template v-slot:headerContentRender>
      <div>
        <a-menu
          mode="horizontal"
          :selected-keys="selectedMenu"
          :style="{ lineHeight: '64px' }"
        >
          <a-menu-item v-for="(item,index) in menus" :key="item.path" @click="handleSideMenus(item)">
            <a-icon :component="item.meta.icon" />
            {{ item.meta.title }}
            <a-divider v-if="index !== menus.length - 1" style="margin: 0 -20px 0 20px; height: 1.9em" type="vertical" />
          </a-menu-item>
        </a-menu>
      </div>
    </template>
    <template v-slot:rightContentRender>
      <right-content :top-menu="settings.layout === 'topmenu'" :is-mobile="isMobile" :theme="settings.theme" />
    </template>
    <router-view v-if="!$store.state.contentIsNeedRefresh" />
  </pro-layout>
</template>

<script>
import { SettingDrawer, updateTheme } from '@ant-design-vue/pro-layout'
import { i18nRender } from '@/locales'
import { mapState } from 'vuex'
import { CONTENT_WIDTH_TYPE, SIDEBAR_TYPE, TOGGLE_MOBILE_TYPE } from '@/store/mutation-types'

import defaultSettings from '@/config/defaultSettings'
import RightContent from '@/components/GlobalHeader/RightContent'

import MultiTab from '@/components/MultiTab'

export default {
  name: 'BasicLayout',
  components: {
    SettingDrawer,
    RightContent,
    MultiTab
  },
  data() {
    return {
      // preview.pro.antdv.com only use.
      isProPreviewSite: process.env.VUE_APP_PREVIEW === 'true' && process.env.NODE_ENV !== 'development',
      // end
      isDev: process.env.NODE_ENV === 'development',

      // base
      menus: [],
      sideMenus: [],
      selectedMenu: ['/home'],
      // 侧栏收起状态
      collapsed: false,
      title: defaultSettings.title,
      multiTab: defaultSettings.multiTab,
      settings: {
        // 布局类型
        layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
        // CONTENT_WIDTH_TYPE
        contentWidth: defaultSettings.layout === 'sidemenu' ? CONTENT_WIDTH_TYPE.Fluid : defaultSettings.contentWidth,
        // 主题 'dark' | 'light'
        theme: defaultSettings.navTheme,
        // 主色调
        primaryColor: defaultSettings.primaryColor,
        fixedHeader: defaultSettings.fixedHeader,
        fixSiderbar: defaultSettings.fixSiderbar,
        colorWeak: defaultSettings.colorWeak,

        openKeys: defaultSettings.openKeys,

        hideHintAlert: false,
        hideCopyButton: false
      },
      // 媒体查询
      query: {},

      // 是否手机模式
      isMobile: false
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: state => state.permission.addRouters
    })
  },
  watch: {
    collapsed(val) {
      console.log(val);
      if (val) {
        this.settings['openKeys'] = null
      } else {
        this.settings['openKeys'] = defaultSettings.openKeys
      }
    }
  },
  created() {
    this.creatInit()
    // 处理侧栏收起状态
    this.$watch('collapsed', () => {
      this.$store.commit(SIDEBAR_TYPE, this.collapsed)
    })
    this.$watch('isMobile', () => {
      this.$store.commit(TOGGLE_MOBILE_TYPE, this.isMobile)
    })
  },
  mounted() {
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }

    // first update color
    // TIPS: THEME COLOR HANDLER!! PLEASE CHECK THAT!!
    if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
      updateTheme(this.settings.primaryColor)
    }
  },
  methods: {
    i18nRender,
    creatInit() {
      // 一级菜单默认选择
      if (this.$route.matched) {
        this.selectedMenu = [this.$route.matched[1].path]
      }
      const routes = this.mainMenu.find(item => item.path === '/')
      const menus = (routes && routes.children) || []
      // 处理一级菜单显示
      this.menus = menus.filter(item => {
        return !item.hidden
      })
      // 二级菜单默认展示
      this.menus.forEach(value => {
        if (value.path === this.$route.matched[1].path) {
          this.sideMenus = value.children
        }
      })
      // 登录跳转
      // if (this.$route.path === '/index/home' && this.menus && this.menus.length) {
      //   this.handleSideMenus(this.menus[0])
      // }
    },
    refresh() {
      this.$store.state.contentIsNeedRefresh = true
      this.$nextTick(() => {
        this.$store.state.contentIsNeedRefresh = false
      })
    },
    handleMediaQuery(val) {
      this.query = val
      if (this.isMobile && !val['screen-xs']) {
        this.isMobile = false
        return
      }
      if (!this.isMobile && val['screen-xs']) {
        this.isMobile = true
        this.collapsed = false
        this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
        // this.settings.fixSiderbar = false
      }
    },
    handleCollapse(val) {
      this.collapsed = val
    },
    handleSettingChange({ type, value }) {
      type && (this.settings[type] = value)
      switch (type) {
        case 'contentWidth':
          this.settings[type] = value
          break
        case 'layout':
          if (value === 'sidemenu') {
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
          } else {
            this.settings.fixSiderbar = false
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fixed
          }
          break
      }
    },
    handleSideMenus(item) {
      if (item.children[0].children) {
        this.$router.push({ path: item.children[0].children[0].path })
        this.sideMenus = item.children
        this.selectedMenu = [item.path]
      } else if (item.children[0].path === '/couponManage/coupon') {
        // TODO 优惠券系统还在开发中
        // const isProd = process.env.NODE_ENV === 'production'
        // const testurl = 'https://www.huparking.com/bohu-coupon-front/index.html'
        // const produrl = 'https://www.huparking.com/bohu-coupon-front/index.html'
        // window.open(isProd ? produrl : testurl, '_blank')
        console.warn('优惠券系统还在开发中')
      } else if (item.children[0].path === '/videoControl') {
        const url = this.$router.resolve({
          path: '/videoControl'
        })
        window.open(url.href, '_blank')
      } else {
        this.$router.push({ path: item.children[0].path })
        this.sideMenus = item.children
        this.selectedMenu = [item.path]
      }
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
@import "./BasicLayout.less";
</style>
